import React from 'react';
import { DarkInputButton } from '../style';

export const BackgroundInput = ({ name, onChange }) => {
    return (
        <label>
            <DarkInputButton htmlFor={name}>Upload</DarkInputButton>
            <input onChange={onChange} name={name} id={name} type={'file'} style={{ display: 'none' }} />
        </label>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/Settings/BackgroundInput.js